import { render, staticRenderFns } from "./newTrainingRefItem.vue?vue&type=template&id=529f8086&scoped=true"
import script from "./newTrainingRefItem.vue?vue&type=script&lang=js"
export * from "./newTrainingRefItem.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style2 from "./newTrainingRefItem.vue?vue&type=style&index=2&id=529f8086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529f8086",
  null
  
)

export default component.exports